@if (breadcrumbPath.length > 0) {
  <div class="cnt-titolo-settings">
    <ng-container
      [ngTemplateOutlet]="useInDialog ? breadcrumbReadOnly : breadcrumbFunzionale"
    ></ng-container>
  </div>
}

<!-- ========================= -->
<!-- Breadcrumb Funzionale -->
<!-- ========================= -->
<ng-template #breadcrumbFunzionale>
  <nav class="breadcrumb">
    @for (folder of visibleBreadcrumbs; track $index; let isLast = $last) {
      <a
        [matTooltip]="folder.name"
        matTooltipPosition="above"
        *ngIf="!folder.isEllipsis"
        (click)="onBreadcrumbClick(folder)"
        [ngClass]="isLast ? 'folder-last' : 'folder-pointer'"
      >
        {{ folder.name }}
      </a>

      <span *ngIf="folder.isEllipsis" class="ellipsis">...</span>

      @if (!isLast && !folder.isEllipsis) {
        <span class="material-icons-outlined">keyboard_arrow_right</span>
      }
    }
  </nav>

  <app-menu-folder [isFolder]="true" [folderSelezionato]="folderSelezionato"></app-menu-folder>
</ng-template>

<!-- ========================= -->
<!-- Breadcrumb ReadOnly -->
<!-- ========================= -->
<ng-template #breadcrumbReadOnly>
  <div class="breadcrumb">
    @for (folder of visibleBreadcrumbs; track $index; let isLast = $last) {
      @if (!isDialogCreazione) {
        <!-- Link o Ellipsis -->
        @if (!folder.isEllipsis) {
          <a [ngClass]="isLast ? 'folder-last' : 'folder-no-pointer '">
            {{ isLast ? lastFolderDynamic : folder.name }}
          </a>
        } @else {
          <span class="ellipsis">...</span>
        }

        <!-- Freccia -->
        @if (!isLast && !folder.isEllipsis) {
          <span class="material-icons-outlined">keyboard_arrow_right</span>
        }
      } @else {
        <!-- Link o Ellipsis in dialog -->
        @if (!folder.isEllipsis) {
          <a class="folder-no-pointer">{{ folder.name }}</a>
        } @else {
          <span class="ellipsis">...</span>
        }

        <!-- Freccia -->
        @if (!folder.isEllipsis) {
          <span class="material-icons-outlined">keyboard_arrow_right</span>
        }

        <!-- Ultimo elemento dinamico -->
        @if (isLast) {
          @if (lastFolderDynamic) {
            <a class="folder-last">{{ lastFolderDynamic }}</a>
          } @else {
            <a class="placeholder-crea-folder">Inserisci il nome della cartella...</a>
          }
        }
      }
    }
  </div>
</ng-template>
